import moment from 'moment';
import { Skeleton } from 'antd';
import React from 'react';
import { useGlobalState } from '../../../store/state';
import './ProfileAboutComponent.styles.scss';

const ProfileAboutComponent = ({ loading }) => {
  const [user] = useGlobalState('user');
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  return (
    <div className="col-md-12 px-2">
      <div className="common_card p-3 profile_about_card h-100">
        <div className="row">
          <div className="col-md-5">
            {
              loading?(
                <div className="profile_about_card--info">
                  <Skeleton active
                    paragraph={{ rows: 4 }}/>
                </div>
              ):(
                <div className="profile_about_card--info">
                  <h5>About </h5>
                  <p>{user.shortinfo || 'No Info Added in Profile'}</p>
                </div>
              )
            }
          </div>
          <div className="col-md-7">
            <div className="profile_about_card_dem">
              {
                loading?(
                  <div className="profile_about_card--info">
                    <Skeleton active
                      paragraph={{ rows: 8 }}/>
                  </div>
                ):(
                  <>
                    <h5>Demographics</h5>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Location</td>
                          <td>{capitalize(user.address.city) || 'N/A'}, {capitalize(user.address.country) || ''}</td>
                        </tr>
                        <tr>
                          <td>Gender</td>
                          <td>{capitalize(user.gender) || 'N/A'}</td>
                        </tr>
                        <tr>
                          <td>Age</td>
                          <td>{moment.utc(user.date_of_birth).fromNow('years').split(' ')[0] || 'N/A'}</td>
                        </tr>

                        <tr>
                          <td>Languages</td>
                          <td>
                            {`${user.languages || 'N/A'}`}
                          </td>
                        </tr>
                        <tr>
                          <td>Address</td>
                          <td>{capitalize(user.address.line1) || 'N/A'}, {capitalize(user.address.line2) || ''},
                            {capitalize(user.address.city) || ''} - {user.address.pin || ''}, {capitalize(user.address.country) || ''}</td>
                        </tr>
                        {/* <tr>
                                                <td>Education</td>
                                                <td>n/a</td>
                                            </tr> */}
                        {/* <tr>
                                                <td>Profession</td>
                                                <td>Cricketer</td>
                                            </tr> */}
                        <tr>
                          <td>Interests</td>
                          <td>
                            {
                              user.interests && user.interests.length ?
                                user.interests.map((interest, index) => (
                                  <>
                                    <span key={interest}>{capitalize(interest)}</span>
                                    {index !==(user.interests.length -1)? ', ':' '}
                                  </>
                                )):
                                'N/A'
                            }
                          </td>
                        </tr>
                        {/* <tr>
                                                <td>Relationship status</td>
                                                <td>{user.relationStatus || 'N/A'}</td>
                                            </tr> */}
                        <tr>
                          <td>Flynt Verified</td>
                          <td>{user.verified ? 'Yes' : 'No'}</td>
                        </tr>
                        {/* <tr>
                                                <td>Premium User</td>
                                                <td>{user.is_premium ? 'Yes' : 'No'}</td>
                                            </tr> */}
                        {/* <tr>
                                                <td>Children</td>
                                                <td>{user.kids || 'N/A'}</td>
                                            </tr> */}
                        {/* <tr>
                                                <td>Pets</td>
                                                <td>{user.pets || 'N/A'}</td>
                                            </tr> */}
                        {/* <tr>
                                                <td>Brands</td>
                                                <td>{user.brands}</td>
                                            </tr> */}
                      </tbody>
                    </table>
                  </>
                )
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileAboutComponent;
